import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Empty_Protocol17025Chart_Interface, Protocol17025Chart_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Chart_Interface';

@Component({
  selector: 'app-Protocol17025Chart_Co',
  templateUrl: './Protocol17025Chart_Co.component.html',
  styleUrls: ['./Protocol17025Chart_Co.component.scss']
})
export class Protocol17025Chart_CoComponent implements OnInit {

  @Input() inner_17025_Cat: Array<Protocol17025Chart_Interface> = []
  @Output() On_Add_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Edit_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Remove_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Up_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Down_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Cut_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_Child_Action = new EventEmitter<Protocol17025Chart_Interface>();
  @Output() On_File_Action = new EventEmitter<Protocol17025Chart_Interface>();

  constructor() { }

  ngOnInit() {
  }




  OnSet_Add_Action(item: Protocol17025Chart_Interface) {
    this.On_Add_Action.emit(item);
  }

  OnSet_Add_Protocol_Action(item: Protocol17025Chart_Interface) {
    var temp: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
    temp.id=item.id
    temp.title=item.title
    temp.chart_type=2
    this.On_Add_Action.emit(temp);
  }

  OnSet_Add_Form_Action(item: Protocol17025Chart_Interface) {
    var temp: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
    temp.id=item.id
    temp.title=item.title
    temp.chart_type=3
    this.On_Add_Action.emit(temp);
  }

  OnSet_Edit_Action(item: Protocol17025Chart_Interface) {
    this.On_Edit_Action.emit(item);
  }

  OnSet_Remove_Action(item: Protocol17025Chart_Interface) {
    this.On_Remove_Action.emit(item);
  }

  OnSet_Down_Action(item: Protocol17025Chart_Interface) {
    this.On_Down_Action.emit(item);
  }

  OnSet_Child_Action(item: Protocol17025Chart_Interface) {
    this.On_Child_Action.emit(item);
  }

  OnSet_File_Action(item: Protocol17025Chart_Interface) {
    this.On_File_Action.emit(item);
  }

  OnSet_Up_Action(item: Protocol17025Chart_Interface) {
    this.On_Up_Action.emit(item);
  }

  OnSet_Cut_Action(item: Protocol17025Chart_Interface) {
    this.On_Cut_Action.emit(item);
  }

  Change_Visible(item: Protocol17025Chart_Interface) {
    item.childVisible = !item.childVisible
  }



}
